export default "__VITE_ASSET__iHv4m25Z__"